import { SectionsTreeNode } from '../types';

const generateUniqueId = (): string => {
  return Math.random().toString(36).substring(2, 15);
};

export const replaceNullKeysAndFieldsInTree = (treeData: SectionsTreeNode[]): SectionsTreeNode[] => {
  return treeData.map((node) => {
    const newNode: SectionsTreeNode = {
      ...node
    };

    if (node.id === null) {
      newNode.id = `gen_id_${generateUniqueId()}`;
    }

    if (node.children) {
      newNode.children = replaceNullKeysAndFieldsInTree(node.children);
    }

    return newNode;
  });
};
